<select #list
  [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [tabindex]="tabindex" multiple="true" [style.overflow-y]="'scroll'" [style.border]="'5px solid #93EAFC'"
  [style.border-radius]="'unset'" [(ngModel)]="selectedItems">
  <ng-template ngFor let-item [ngForOf]="classificationsListModel.list">
    <option class="list-item" value="{{item.ClassCode}}">{{item.ClassCodeName}}</option>
  </ng-template>
</select>
